import Image from "next/legacy/image";
import { CheckCircle } from "@phosphor-icons/react";

function ContentPreferenceItem({ selected, name, onChange, uuid }) {
  const elementId = `preference-content-${uuid.toLowerCase()}`;
  return (
    <div>
      <input
        type='checkbox'
        id={elementId}
        checked={selected || false}
        onChange={onChange}
        value={uuid}
        className='hidden'
      />
      <label
        className={
          selected
            ? "relative flex items-center px-5 py-3 border rounded-md cursor-pointer border-white/10 bg-white text-background"
            : "text-white relative flex items-center px-5 py-3 border rounded-md cursor-pointer border-white/10"
        }
        htmlFor={elementId}
      >
        <span className='flex items-center justify-center w-5 h-5 mr-2 -ml-1.5 border rounded-full bg-white/5 '>
          {selected && <CheckCircle weight='fill' className='w-5 h-5' />}
        </span>
        <p className='inline-flex flex-col items-start gap-1 text-xs font-medium lg:text-base'>
          {name}
        </p>
      </label>
    </div>
  );
}

export default ContentPreferenceItem;
